export default __webpack_public_path__ + "static/media/404.5e2b4c8d.gif";